exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-toggle=\"toggle\"] {\n  display: none; }\n\n.plus-img-size {\n  width: 15px; }\n\n.disabled {\n  color: #b0adab; }\n\n.header-color-bar {\n  background-color: #e1e6ef !important; }\n\n.isOdd {\n  background-color: #ffffff !important; }\n\n.isEven {\n  background-color: #f5f7f9 !important; }\n\n.font-print {\n  font-size: 0.95rem; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/industry-level/sector-popup-data/sector-popup-data.component.scss
// module id = ../../../../../src/app/industry-level/sector-popup-data/sector-popup-data.component.scss
// module chunks = main